module.exports = __webpack_public_path__ + "static/img/2设计师1.82553be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/设计市场/2设计师1.png
// module id = N100
// module chunks = 1